import styled from 'styled-components'
import { Box, MenuItem } from 'core/components/Core'

export const Container = styled.div`
  #product-freight-select-weightUn,
  #product-freight-select-dimensionUn,
  #product-freight-select-standard_package {
    padding: 18.5px 24px 10.5px;
  }
`

const StyledMenuItem = styled(MenuItem)`
  &[class*='MuiMenuItem-root'] > div {
    display: flex;
    justify-content: space-between;
    flex: 1;
  }
`

const StyledMenuItemContainer = styled(Box)`
  display: flex;
`

export { StyledMenuItem, StyledMenuItemContainer }
